import { HugeiconsIcon, type HugeiconsIconProps } from "@hugeicons/react";
import { Loading03Icon as Loader2Icon } from "@hugeicons/core-free-icons";

import { cn } from "@/lib/utils";

function Spinner({ className, ...props }: Omit<HugeiconsIconProps, "icon">) {
  return (
    <output aria-label="Loading" className="inline-flex">
      <HugeiconsIcon
        icon={Loader2Icon}
        data-slot="spinner"
        className={cn("size-4 animate-spin", className)}
        {...props}
      />
    </output>
  );
}

export { Spinner };
